/* globals LassoCRM */
;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.conciergeForm = (function () {
    function open (element) {
      const cname = $(element).attr('data-community-name')

      // console.log('opening concierge form...', $.fancybox.update)
      $('.js-openConciergeForm').trigger('click')
      // $('.web-concierge-form').find('input[class~="firstname"]').val(cname); // for testing
      $('.web-concierge-form').find('input[class~="community-of-interest"]').val(cname)
      // console.log('opening concierge form...', $.fancybox.update)
      $('body').on('submitResponse.resizeModal', $.fancybox.update)
    }

    function initialize () {
      $('a[data-open-concierge-form]').on('click', function (e) {
        e.preventDefault()
        e.stopPropagation()
        open(e.target)
      })

      const $formContent = $('#concierge-form__container').detach()
      $('.js-openConciergeForm').fancybox({
        type: 'html',
        padding: 10,
        content: $formContent,
        beforeClose: function () {
          $('.web-concierge-form').find('input[class~="community-of-interest"]').val('') // reset just in case
        },
        afterShow: function () {
          // init_all_the_ninja_things();
          // console.log('afterShow?')
          $('body').on('submitResponse.resizeModal', function () {
            // console.log('submitResponse handler...')
            $.fancybox.update()
          })

          if (window.LassoCRM) {
            $('.web-concierge-form').find('[name="guid"]').val(LassoCRM.tracker.readCookie('ut'))
          }

          // duplicating here cuz NinjaForms only sets up these listeners on doc.ready
          jQuery('div.label-inside input, div.label-inside textarea').focus(function () {
            const label = jQuery('#' + this.id + '_label_hidden').val()
            if (this.value === label) {
              this.value = ''
            }
          })

          jQuery('div.label-inside input, div.label-inside textarea').blur(function () {
            const label = jQuery('#' + this.id + '_label_hidden').val()
            if (this.value === '') {
              this.value = label
            }
          })
        }
      })
    }

    return {
      initialize: initialize,
      open: open
    }
  }())

  $(function () {
    eah.conciergeForm.initialize()
  })
}(jQuery, window))
